module.exports = __webpack_public_path__ + "img/contact.56d9635b.jpg";